import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/AlertDialog";
import { Button } from "@/components/ui/Button";
import { IMAGES } from "@/assets/IMAGES";

type AlertDialogProps = {
  trigger?: React.ReactNode;
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  isBodyAllow?: boolean;
  body?: () => React.ReactNode;
  confirmVariant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link";
  cancelVariant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link";
  open?: any;
  onOpenChange?: (open: boolean) => void;
  className?: string;
};

const CustomAlertDialog: React.FC<AlertDialogProps> = ({
  trigger,
  title,
  description,
  onConfirm,
  onCancel,
  confirmText = "Continue",
  cancelText = "Cancel",
  confirmVariant = "default",
  cancelVariant = "outline",
  open,
  onOpenChange,
  isBodyAllow = false,
  body,
  className,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}

      <AlertDialogContent className={className}>
        {isBodyAllow && body ? (
          <>
            <AlertDialogHeader>
              <div className="flex items-center justify-end">
                <AlertDialogTitle>
                  <img
                    src={IMAGES.close}
                    onClick={onCancel}
                    alt=""
                    className="size-8 hover:cursor-pointer"
                  />
                </AlertDialogTitle>
              </div>
            </AlertDialogHeader>
            {body()}
          </>
        ) : (
          <>
            <AlertDialogHeader>
              <AlertDialogTitle className="flex items-center justify-between relative">
                <div>
                  <img
                    src={IMAGES.delete_warning}
                    alt=""
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <div>
                  <img
                    src={IMAGES.cross}
                    alt=""
                    className="w-3 h-3 object-contain hover:cursor-pointer"
                    onClick={onCancel}
                  />
                </div>
              </AlertDialogTitle>
              <AlertDialogDescription className="text-black">
                {description}
              </AlertDialogDescription>
            </AlertDialogHeader>

            <div className="flex items-center justify-end">
              <AlertDialogFooter className="w-[10rem]">
                <AlertDialogCancel onClick={onCancel} asChild>
                  <Button variant={cancelVariant}>{cancelText}</Button>
                </AlertDialogCancel>

                <AlertDialogAction onClick={onConfirm} asChild>
                  <Button variant="solid" className="font-normal">
                    {confirmText}
                  </Button>
                </AlertDialogAction>
              </AlertDialogFooter>
            </div>
          </>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CustomAlertDialog;
